import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
import { SetCustomFieldBlockModel } from "@app/workflow-common/services/models/SetCustomFieldBlockModel";
import { ActivatedRoute } from "@angular/router";
var SetCustomFieldBlockWidgetComponent = /** @class */ (function () {
    function SetCustomFieldBlockWidgetComponent(formBuilder, translate, route) {
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.route = route;
        this.close = new EventEmitter();
        this.isLoading = true;
        this.isFormSubmitted = false;
        this.showDeleteBtn = false;
        // optgroup structure: [{ label, fields: [{ id, text }] }]
        this.sourceFields = [];
        this.objectCustomFields = [];
        this.filteredObjectCustomFields = [];
        this.targetSelect2Instance = undefined;
        this.showTargetSelect = true;
    }
    SetCustomFieldBlockWidgetComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var customFieldTemplates, modelData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.blockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
                        // resolve the form template id (the `:id` route segment) by walking up the route tree
                        this.formTemplateId = this.getFormTemplateId();
                        // fetch the two dropdown value lists (cached, shared HTTP call) before the panel form loads
                        // dropdown 1: current arrive/leave (custom form) template fields, from the workflow PHP API
                        return [4 /*yield*/, CommonDataSource.getCurrentArriveLeaveTemplateFields(this.screenName, this.formTemplateId).then(function (fields) {
                                // date fields are not supported as a mapping source
                                var sourceFieldList = (fields || [])
                                    .filter(function (field) { return field.type !== 'date'; })
                                    .map(function (field) { return ({
                                    id: field.col_name,
                                    text: field.text,
                                    type: field.type,
                                    answerType: field.answerType
                                }); });
                                _this.sourceFields = sourceFieldList.length
                                    ? [{ label: 'Source Field', fields: sourceFieldList }]
                                    : [];
                            })];
                    case 1:
                        // fetch the two dropdown value lists (cached, shared HTTP call) before the panel form loads
                        // dropdown 1: current arrive/leave (custom form) template fields, from the workflow PHP API
                        _a.sent();
                        return [4 /*yield*/, CommonDataSource.getObjectCustomFields(this.screenName)];
                    case 2:
                        customFieldTemplates = _a.sent();
                        this.objectCustomFields = (customFieldTemplates || [])
                            .map(function (template) { return ({
                            label: template.description,
                            fields: (template.fields || []).map(function (field) { return ({ id: field.col_name, text: field.text, templateId: field.templateId, type: field.type, answerType: field.answerType }); })
                        }); })
                            .filter(function (group) { return group.fields.length; });
                        modelData = this.blockObject['model'] ? this.blockObject['model'] : undefined;
                        if (modelData) {
                            this.showDeleteBtn = true;
                        }
                        this.inputModel = new SetCustomFieldBlockModel(modelData);
                        // seed the "Custom field to set:" options from the saved source type (edit); empty for a new block
                        this.filteredObjectCustomFields = this.filterTargetsByType(this.inputModel.sourceFieldAnswerType);
                        this.form = this.formBuilder.group({
                            sourceFieldColName: new FormControl(this.inputModel.sourceFieldColName, [Validators.required]),
                            sourceDisplayValue: new FormControl(this.inputModel.sourceDisplayValue),
                            sourceFieldType: new FormControl(this.inputModel.sourceFieldType),
                            sourceFieldAnswerType: new FormControl(this.inputModel.sourceFieldAnswerType),
                            targetFieldColName: new FormControl(this.inputModel.targetFieldColName, [Validators.required]),
                            targetDisplayValue: new FormControl(this.inputModel.targetDisplayValue),
                            targetFieldTemplateId: new FormControl(this.inputModel.targetFieldTemplateId),
                            targetFieldType: new FormControl(this.inputModel.targetFieldType),
                            targetFieldAnswerType: new FormControl(this.inputModel.targetFieldAnswerType),
                            overrideExisting: new FormControl(this.inputModel.overrideExisting),
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SetCustomFieldBlockWidgetComponent.prototype.getFormTemplateId = function () {
        var route = this.route.snapshot;
        while (route) {
            if (route.params && route.params['id'] != null) {
                return +route.params['id'];
            }
            route = route.parent;
        }
        return this.dagSourceModel.getTemplateId();
    };
    SetCustomFieldBlockWidgetComponent.prototype.getDisplayValue = function (groups, colName) {
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            var match = group.fields.find(function (f) { return f.id == colName; });
            if (match) {
                return {
                    text: match.text,
                    type: match.type,
                    answerType: match.answerType,
                    templateId: match.templateId
                };
            }
        }
        return {
            text: '',
            type: '',
            answerType: '',
            templateId: ''
        };
    };
    SetCustomFieldBlockWidgetComponent.prototype.onSelectSource = function (event) {
        if (event === void 0) { event = null; }
        var DisplayItem = this.getDisplayValue(this.sourceFields, event);
        this.form.get('sourceFieldColName').setValue(event);
        this.form.get('sourceDisplayValue').setValue(event ? DisplayItem.text : '');
        this.form.get('sourceFieldType').setValue(event ? DisplayItem.type : '');
        this.form.get('sourceFieldAnswerType').setValue(event ? DisplayItem.answerType : '');
        // dependent "Custom field to set:" — clear it and narrow to fields of the matching type
        this.onSelectTarget(null);
        this.filteredObjectCustomFields = this.filterTargetsByType(event ? DisplayItem.answerType : '');
        this.rerenderTargetSelect();
    };
    SetCustomFieldBlockWidgetComponent.prototype.filterTargetsByType = function (sourceAnswerType) {
        var allowed = SetCustomFieldBlockWidgetComponent.TYPE_COMPATIBILITY_MAP[sourceAnswerType];
        if (!allowed) {
            return [];
        }
        return (this.objectCustomFields || [])
            .map(function (group) { return ({
            label: group.label,
            fields: (group.fields || []).filter(function (f) { return allowed.includes(f.answerType); })
        }); })
            .filter(function (group) { return group.fields.length; });
    };
    // csSelect2 only reads options at init, so remove and re-add the <select> to re-init it
    SetCustomFieldBlockWidgetComponent.prototype.rerenderTargetSelect = function () {
        var _this = this;
        if (this.targetSelect2Instance) {
            this.targetSelect2Instance.select2('destroy');
            this.targetSelect2Instance = undefined;
        }
        this.showTargetSelect = false;
        setTimeout(function () { _this.showTargetSelect = true; });
    };
    SetCustomFieldBlockWidgetComponent.prototype.setTargetSelect2Instance = function (event) {
        this.targetSelect2Instance = event;
        // disabled until a "Template field to get:" value is selected
        var hasSource = !!this.form.get('sourceFieldColName').value;
        this.targetSelect2Instance.select2('enable', hasSource);
    };
    SetCustomFieldBlockWidgetComponent.prototype.onSelectTarget = function (event) {
        if (event === void 0) { event = null; }
        var DisplayItem = this.getDisplayValue(this.objectCustomFields, event);
        this.form.get('targetFieldColName').setValue(event);
        this.form.get('targetFieldTemplateId').setValue(event ? DisplayItem.templateId : '');
        this.form.get('targetDisplayValue').setValue(event ? DisplayItem.text : '');
        this.form.get('targetFieldType').setValue(event ? DisplayItem.type : '');
        this.form.get('targetFieldAnswerType').setValue(event ? DisplayItem.answerType : '');
    };
    SetCustomFieldBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    SetCustomFieldBlockWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    SetCustomFieldBlockWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var model = new SetCustomFieldBlockModel(this.form.value);
        model.formTemplateId = this.formTemplateId;
        blockObject.model = model;
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    // Mirrors isMappingTypeCompatible() in DiaryEventsFieldsQueries.php — keep both in sync,
    // there is no shared source of truth between the Angular and PHP sides.
    SetCustomFieldBlockWidgetComponent.TYPE_COMPATIBILITY_MAP = {
        'Input': ['Input', 'Text Area'],
        'Text Area': ['Text Area', 'Input'],
        'Number': ['Input', 'Decimal', 'Number'],
        'Decimal': ['Decimal', 'Number'],
        'Custom calculation': ['Custom calculation'],
        'User': ['Input', 'Text Area', 'User'],
        'Single Checkbox': ['Input', 'Text Area'],
        'Radio': ['Input', 'Text Area'],
        'Toggle': ['Input', 'Text Area'],
        'Dropdown': ['Input', 'Text Area'],
        'Input with Selection Choices': ['Input', 'Text Area'],
        'Checkbox': ['Input', 'Text Area'],
    };
    return SetCustomFieldBlockWidgetComponent;
}());
export { SetCustomFieldBlockWidgetComponent };
